import { CHF } from "@/lib/apiClient";

const STATUS = { pending: "EN ATTENTE", accepted: "ACCEPTÉE", preparing: "EN PRÉPARATION", ready: "PRÊTE", completed: "TERMINÉE", refused: "REFUSÉE", cancelled: "ANNULÉE" };

export function ticketHTML(order, settings) {
  const lines = order.items.map((i) => {
    const addons = (i.selected_addons || []).map((a) => `<div class="ad">+ ${a.name}${a.price > 0 ? ` (${CHF(a.price)})` : ""}</div>`).join("");
    const comment = i.comment ? `<div class="cm">» ${i.comment}</div>` : "";
    const unit = i.base_price + (i.selected_addons || []).reduce((s, a) => s + a.price, 0);
    return `<div class="it"><div class="row"><span>${i.qty}× ${i.name}</span><span>${CHF(unit * i.qty)}</span></div>${addons}${comment}</div>`;
  }).join("");

  const promos = (order.discount_labels || []).map((l) => `<div class="row small"><span>${l}</span><span></span></div>`).join("");

  return `<!doctype html><html><head><meta charset="utf-8"><title>Ticket #${order.order_number}</title>
  <style>
    @page { size: 80mm auto; margin: 0; }
    * { font-family: 'Courier New', monospace; }
    body { width: 80mm; margin: 0; padding: 6mm 4mm; color: #000; }
    h1 { font-size: 20px; text-align: center; margin: 0; }
    .center { text-align: center; }
    .big { font-size: 26px; font-weight: bold; text-align:center; }
    hr { border: none; border-top: 1px dashed #000; margin: 6px 0; }
    .row { display: flex; justify-content: space-between; font-size: 13px; }
    .small { font-size: 11px; }
    .it { margin: 4px 0; font-size: 13px; }
    .ad, .cm { font-size: 11px; padding-left: 10px; }
    .cm { font-style: italic; }
    .tot { font-size: 16px; font-weight: bold; }
  </style></head><body>
  <h1>${settings?.restaurant_name || "Asia Take Away"}</h1>
  <div class="center small">${settings?.address || ""}</div>
  <div class="center small">${settings?.phone || ""}</div>
  <hr/>
  <div class="big">#${order.order_number}</div>
  <div class="center">${order.mode === "delivery" ? "LIVRAISON" : "À EMPORTER"} — ${STATUS[order.status] || ""}</div>
  <div class="center small">Heure prévue : ${order.timeslot || "-"}</div>
  ${order.mode === "delivery" ? `<div class="small">${order.customer?.address || ""} ${order.customer?.postal_code || ""}</div>` : ""}
  <div class="small">Tél : ${order.customer?.phone || ""}</div>
  <hr/>
  ${lines}
  <hr/>
  <div class="row"><span>Sous-total</span><span>${CHF(order.subtotal)}</span></div>
  ${promos}
  ${order.discount > 0 ? `<div class="row"><span>Réductions</span><span>- ${CHF(order.discount)}</span></div>` : ""}
  ${order.delivery_fee > 0 ? `<div class="row"><span>Livraison</span><span>${CHF(order.delivery_fee)}</span></div>` : ""}
  <div class="row tot"><span>TOTAL</span><span>${CHF(order.total)}</span></div>
  <div class="row small"><span>dont TVA ${order.vat_rate}%</span><span>${CHF(order.vat_amount)}</span></div>
  <div class="row small"><span>Total HT</span><span>${CHF(order.total_ht)}</span></div>
  <hr/>
  <div class="center small">Merci et à bientôt !</div>
  </body></html>`;
}

export function printTicket(order, settings) {
  const w = window.open("", "_blank", "width=380,height=640");
  if (!w) return;
  w.document.write(ticketHTML(order, settings));
  w.document.close();
  w.focus();
  setTimeout(() => { w.print(); }, 300);
}
